module.exports = __webpack_public_path__ + "img/winter_collection_bg.1adca6ef.jpg";